import { gql } from '@apollo/client';
import UPDATE_STUDENT_SETTING_FRAGMENT from '../../fragments/update-student-setting-fragment';

const UPDATE_WDT_STUDENT_CHARACTER_ORDER_SETTING = gql`
  mutation updateWdtStudentSettingCharacterOrder(
    $data: [UpdateWdtStudentSettingCharacterOrderInput!]!
  ) {
    updateWdtStudentSettingCharacterOrder(data: $data) {
      ...UpdateStudentSettingFragment
    }
  }
  ${UPDATE_STUDENT_SETTING_FRAGMENT}
`;

export default UPDATE_WDT_STUDENT_CHARACTER_ORDER_SETTING;
